import React, { Component } from 'react'
import Time from 'material-ui/svg-icons/device/access-time'
import { checkMobile, isSentryBreadcrumbs } from '../lib/lib'

const formattedSeconds = (sec) =>
  Math.floor(sec / 60) +
  ':' +
  ('0' + sec % 60).slice(-2)

export default class Timer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      secondsElapsed: 0,
      timerFontColor: '#8996A9',
      lastClearedIncrementer: null
    }
  }

  componentDidMount () {
    this.handleStartTimer()
  }

  componentWillUnmount () {
    this.incrementer && clearInterval(this.incrementer)
    this.incrementer = false
  }

  handleStartTimer () {
    try {
      this.incrementer = setInterval(() => {
        this.setState({
          secondsElapsed: this.state.secondsElapsed + 1
        })
      }, 1000)
    }
    catch (error) {
      const message = 'Timer handleStartTimer() failed'
      isSentryBreadcrumbs(error, message)
    }
  }

  render () {
    return (
      <div>
        <div className='flex items-center ml1'
             style={checkMobile() ? {} : {position: 'absolute', height: '8vh', bottom: '5vh', zIndex: 150}}>
          <Time className='mr3' style={{fill: this.state.timerFontColor}}/>
          <div style={{fontSize: 20, color: this.state.timerFontColor}}>
            {formattedSeconds(this.state.secondsElapsed)}s
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Timer.js